"use client"
import { FORM_ERROR, GuideForm } from "./GuideForm"
import { CreateGuideSchema } from "../schemas"
import { useMutation } from "@blitzjs/rpc"
import createGuide from "../mutations/createGuide"

export function NewGuide(props) {
  const [createGuideMutation] = useMutation(createGuide)
  return (
    <GuideForm
      submitText="create guide"
      schema={CreateGuideSchema}
      onSubmit={async (values) => {
        try {
          const guide = await createGuideMutation(values)
          if (typeof props.onCreate === "function") {
            await props.onCreate(guide)
          }
        } catch (error: any) {
          console.error(error)
          return {
            [FORM_ERROR]: error.toString(),
          }
        }
      }}
    />
  )
}
